export const PENDING_UPDATE_BULK_STORE = "PENDING_UPDATE_BULK_STORE";
export const SUCCESS_UPDATE_BULK_STORE = "SUCCESS_UPDATE_BULK_STORE";
export const ERROR_UPDATE_BULK_STORE = "ERROR_UPDATE_BULK_STORE";

export const PENDING_UPDATE_PASSWORD = "PENDING_UPDATE_PASSWORD";
export const SUCCESS_UPDATE_PASSWORD = "SUCCESS_UPDATE_PASSWORD";
export const ERROR_UPDATE_PASSWORD = "ERROR_UPDATE_PASSWORD";